import { logError } from '../api/client';

export function initErrorLogger() {
    // Синхронные ошибки и ошибки загрузки ресурсов
    window.onerror = function (message, source, lineno, colno, error) {
        console.error('Перехвачена ошибка:', { message, source, lineno, colno, error });

        logError({
            type: 'onerror',
            message: String(message),
            source,
            lineno,
            colno,
            stack: error?.stack
        });
    };

    window.onunhandledrejection = function (event) {
        console.error('Перехвачена необработанная ошибка промиса:', event.reason);

        logError({
            type: 'unhandledrejection',
            message: event.reason?.message || String(event.reason),
            stack: event.reason?.stack
        });
    };
}